// extracted by mini-css-extract-plugin
export var actionButton = "_kj-t";
export var buttonContainer = "_kj-0";
export var buttonContainer2 = "_kj-1";
export var buttonSection = "_kj-2";
export var details = "_kj-3";
export var dropdownItem = "_kj-5";
export var dropdownItemsContainer = "_kj-4";
export var fileInput = "_kj-r";
export var headerButton = "_kj-6";
export var icon = "_kj-7";
export var input = "_kj-8";
export var macroListItem = "_kj-9";
export var mainContent = "_kj-a";
export var microText = "_kj-b";
export var modal = "_kj-w";
export var optionsButton = "_kj-c";
export var paperclip = "_kj-s";
export var pillContent = "_kj-d";
export var preview = "_kj-e";
export var preview2 = "_kj-f";
export var quillEditor = "_kj-q";
export var selectedMacro = "_kj-g";
export var sidebar = "_kj-h";
export var sidebarHeader = "_kj-j";
export var sidebarList = "_kj-i";
export var sidebarListItem = "_kj-k";
export var sidebarSearch = "_kj-l";
export var snoozeDurationWrapper = "_kj-v";
export var statusPillContainer = "_kj-m";
export var tagsContainer = "_kj-n";
export var unselectedMacro = "_kj-o";
export var variable = "_kj-u";
export var wrapper = "_kj-p";